module.exports = __webpack_public_path__ + "img/6_h_uk.feb28bf1.svg";